/**
 * A file's type as the portal sends it: the browser's word for it, else the
 * one its extension says (drawings, models, sheets and some pictures come
 * without one), else bytes. What a screen accepts is the API's to say.
 */
const BY_EXTENSION: Record<string, string> = {
  pdf: 'application/pdf',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  webp: 'image/webp',
  gif: 'image/gif',
  heic: 'image/heic',
  heif: 'image/heif',
  avif: 'image/avif',
  tif: 'image/tiff',
  tiff: 'image/tiff',
  dwg: 'image/vnd.dwg',
  dxf: 'image/vnd.dxf',
  skp: 'application/vnd.sketchup.skp',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  csv: 'text/csv',
  zip: 'application/zip',
};

export function typeOf(file: Pick<File, 'type' | 'name'>): string {
  if (file.type) return file.type;
  return BY_EXTENSION[file.name.split('.').pop()?.toLowerCase() ?? ''] ?? 'application/octet-stream';
}
